/**
 * PURPOSE: Contains logic related to the application bootstrap process.
 */

// libraries
import type { ReduxMiddleware, GetRemainingReducers } from '@makemydeal/dr-shared-store';
import { buildBootstrapMiddleware } from '@makemydeal/dr-shared-store';

// interfaces/types
import type { SalesCheckinRootState } from '@makemydeal/dr-sales-checkin-store';
import { getBuyerLastName } from '@makemydeal/dr-sales-checkin-store';

// utils
import { getRemainingReducers } from '../reducers/remainingReducers';

// constants
import { APP_NAME } from '../../../constants';

export const internalBuildBootstrapMiddleware = (getRemainingReducers: GetRemainingReducers) => {
    return buildBootstrapMiddleware<SalesCheckinRootState>({
        getGlobalRemainingReducers: getRemainingReducers,
        getDocumentTitle: (state) => {
            const lastName = getBuyerLastName(state);
            return lastName ? `${APP_NAME} - ${lastName}` : APP_NAME;
        }
    });
};

export const bootstrapMiddleware: ReduxMiddleware<SalesCheckinRootState> = internalBuildBootstrapMiddleware(getRemainingReducers);
